import Icon from '../components/Icon.vue'

Icon.register({
  'chess-board': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M255.9 0.2v64h-64v-64h64zM0 64.2h64v64h-64v-64zM128 0.2v64h-64v-64h64zM192 256.1h64v64h-64v-64zM0 192.1h64v64h-64v-64zM383.9 0.2v64h-64v-64h64zM511.9 0.2v64h-64v-64h64zM128 256.1v64h-64v-64h64zM511.8 448h-64v-64h64v64zM511.8 320h-64v-64h64v64zM383.9 512v-64h64v64h-64zM511.9 192.1h-64v-64h64v64zM128 512v-64h64v64h-64zM0 512v-64h64v64h-64zM255.9 512v-64h64v64h-64zM0 320.1h64v64h-64v-64zM319.9 128.1h-64v-64h64v64zM255.9 256.1v-64h64v64h-64zM191.9 384.2h64v64h-64v-64zM319.9 320.1v-64h64v64h-64zM319.9 192.2v-64h64v64h-64zM319.9 384.1h64v64h-64v-64zM64 384h64v64h-64v-64zM192 128.1h-64v-64h64v64zM383.9 384v-64h64v64h-64zM255.9 192.1h-64v-64h64v64zM383.9 64.2h64v64h-64v-64zM255.9 320.1h64v64h-64v-64zM191.9 192.1l0.1 64h-64v-64h63.9zM383.8 256.1v-64h64v64h-64zM128 128.1v64h-64v-64h64zM128 320.1h64v64h-64v-64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-board.js
// module id = 1178
// module chunks = 0